/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsModule_itemSearch = {
    readonly meta: {
        readonly attributeDisplayName: string | null;
        readonly header: string | null;
    } | null;
    readonly interiorPhotos: {
        readonly photos: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoCarousel_photos">;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsPhotoModalRenderer_interiorPhotos" | "SbRespInteriorsPhotoGallery_interiorPhotos" | "SbRespInteriorsPhotoCarousel_interiorPhotos" | "interiorsModuleHelpers_interiorPhotos">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoCarousel_itemSearch" | "SbRespInteriorsPhotoGallery_itemSearch">;
    readonly " $refType": "SbRespInteriorsModule_itemSearch";
};
export type SbRespInteriorsModule_itemSearch$data = SbRespInteriorsModule_itemSearch;
export type SbRespInteriorsModule_itemSearch$key = {
    readonly " $data"?: SbRespInteriorsModule_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsModule_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsModule_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attributeDisplayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseInteriorPhotosModule",
      "kind": "LinkedField",
      "name": "interiorPhotos",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbRespInteriorsPhotoCarousel_photos"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedInteriorsPhotoModalRenderer_interiorPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespInteriorsPhotoGallery_interiorPhotos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespInteriorsPhotoCarousel_interiorPhotos"
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "interiorsModuleHelpers_interiorPhotos",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InteriorPhotosModulePhotoSearchParam",
              "kind": "LinkedField",
              "name": "photoSearchParam",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsPhotoCarousel_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsPhotoGallery_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'aae0c86ae57752013495e2368536cdb3';
export default node;
